/**
 * Загрузка файла на сервер
 * @return путь к файлу
 */
const uploadFile = function(data) {
  // для отправки файлов определяем data через FormData
  let formData = new FormData();
  for (const prop in data) {
    if (data.hasOwnProperty(prop)) {
      formData.append(prop, data[prop]);
    }
  }
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/file/upload",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Удаление файла с сервера
 */
const deleteFile = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/file/delete",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Получение скриншота по url
 */
const screenshot = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/screenshoter/makeScreenGreatAgain",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { screenshot, deleteFile, uploadFile };
